import { render, staticRenderFns } from "./ActivationBriefOrdersListProvider.vue?vue&type=template&id=6a6032a0&"
import script from "./ActivationBriefOrdersListProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefOrdersListProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports